var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customScenario[0].data.length)?_c('VueApexCharts',{staticStyle:{"width":"100%","min-width":"400px"},attrs:{"type":"area","height":"350","options":_vm.customScenarioChartOptions,"series":_vm.customScenario}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }